import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

const MAX_PERCENTAGE = 100;
const PRIMARY = 'var(--primary-color)';
const GREY = 'var(--grey-goose-color)';

@Directive({
  selector: '[cvAudioProgressBackground]',
  standalone: true,
})
export class AudioProgressBackgroundDirective implements OnChanges {
  @Input() rangeValue: number = 0;
  @Input() duration: number = 0;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnChanges(): void {
    this.setBackground();
  }

  private setBackground(): void {
    if (!this.rangeValue || !this.duration) {
      this.el.nativeElement.style.background = GREY;
      return;
    }

    const percent = (Number(this.rangeValue) / this.duration) * MAX_PERCENTAGE || 0;
    this.el.nativeElement.style.background = `linear-gradient(to right, ${PRIMARY} 0%, var(--fenix-orange) ${percent}%, ${GREY} ${percent}%, ${GREY} 100%)`;
  }
}
